import React from "react"
import Home from "../../views/home/Home.view"
import { AppRoutes } from "../../consts/appRoutes.consts"
import Sandbox from "../../views/sandbox/Sandbox.view"
import { Logout } from "../../views/auth/Logout.view"
import ClientReportPresentationMode from "../../views/clientReport/controllers/Download/ClientReportPresentationMode.controller"
import { Survey } from "../../views/surveys/Survey.view"

export const DEFAULT_ROUTES = [
  {
    path: AppRoutes.home.index,
    element: <Home />,
  },
  {
    path: AppRoutes.auth.loginExplicit,
    element: <Home />,
  },
  {
    path: "/logout",
    element: <Logout />,
  },
  {
    path: "/client-report",
    element: <ClientReportPresentationMode />,
    withoutMainLayout: true,
  },
  {
    path: AppRoutes.surveys.survey,
    element: <Survey />,
    withoutMainLayout: true,
    withoutContentLayout: true,
  },
  ...((
    process.env.REACT_APP_ENVIROMENT !== "production" // Available for development and testing only
  ) ?
    [
      {
        path: "/sandbox",
        element: <Sandbox />,
      },
    ]
  : []),
]
